import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { FacetUrlListingPluginService } from './plugin/listing.plugin.service';
import { FacetUrlMetaAlternatePluginService } from './plugin/meta-alternate.plugin.service';
import { FacetUrlMetaPluginService } from './plugin/meta.plugin.service';

export function provideDfModuleFacetUrl(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(FacetUrlListingPluginService).appInitialize();
            inject(FacetUrlMetaPluginService).appInitialize();
            inject(FacetUrlMetaAlternatePluginService).appInitialize();
        })
    ]);
}
